// extracted by mini-css-extract-plugin
export default {"Form":"Login_Form__KsVgO"};